import type { Campus } from '../types';

interface CampusConfig extends Campus {
  possuiSedes?: boolean;
  mapStatus?: string;
  sedes?: Record<string, {
    nome: string;
    blocos: string[];
  }>;
  blocos?: string[];
  tiposAmbiente?: string[];
  tiposProblema?: string[];
  tiposRelato?: Record<string, any>;
  observacaoMapa?: string;
}

const CAMPUS_DATA: Record<string, CampusConfig> = {
  ap: {
    id: 'ap',
    nome: 'Apucarana',
    sigla: 'AP',
    cidade: 'Apucarana',
    possuiSedes: false,
    mapStatus: 'pendente',
    blocos: [],
    observacaoMapa: 'Mapeamento de blocos/andares/salas ainda será definido pela gestão deste câmpus.'
  },
  cm: {
    id: 'cm',
    nome: 'Campo Mourão',
    sigla: 'CM',
    cidade: 'Campo Mourão',
    possuiSedes: false,
    mapStatus: 'completo',
    blocos: []
  },
  cp: {
    id: 'cp',
    nome: 'Cornélio Procópio',
    sigla: 'CP',
    cidade: 'Cornélio Procópio',
    possuiSedes: false,
    mapStatus: 'completo',
    blocos: []
  },
  ct: {
    id: 'ct',
    nome: 'Curitiba',
    sigla: 'CT',
    cidade: 'Curitiba',
    possuiSedes: true,
    mapStatus: 'completo',
    sedes: {
      centro: {
        nome: 'Centro',
        blocos: [
          'Geral', 'Bloco A', 'Bloco B', 'Bloco C', 'Bloco D', 'Bloco E', 'Bloco F',
          'Bloco G', 'Bloco H', 'Bloco I', 'Bloco J', 'Bloco K', 'Bloco L',
          'Bloco M - Restaurante Universitário', 'Bloco N', 'Bloco O - Ginásio',
          'Bloco P', 'Bloco Q', 'Bloco R - Mini-ginásio', 'Bloco S - DAEFI / Piscina',
          'Bloco T', 'Bloco U', 'Bloco V'
        ]
      },
      neoville: {
        nome: 'Neoville',
        blocos: [
          'Bloco A', 'Bloco B', 'Bloco C', 'Bloco D', 'Bloco E', 'Bloco F',
          'Bloco G', 'Bloco H', 'Bloco J', 'Bloco K', 'Bloco L', 'Bloco M',
          'Bloco N', 'Bloco O', 'Bloco P', 'Bloco Q', 'Bloco R', 'Bloco Z',
          'Áreas de Acesso', 'Área de Circulação'
        ]
      },
      ecoville: {
        nome: 'Ecoville',
        blocos: [
          'Bloco A', 'Bloco B', 'Bloco C', 'Bloco D', 'Bloco E', 'Bloco F',
          'Bloco I', 'Bloco J', 'Bloco K', 'Bloco L', 'Bloco M', 'Bloco N',
          'Áreas de Acesso', 'Área de Circulação'
        ]
      }
    },
    tiposAmbiente: [
      'Salas de Aula / Laboratórios',
      'Áreas Gerais e Administrativas',
      'Circulação / Corredor',
      'Sanitários',
      'Área Externa'
    ],
    tiposProblema: ['Estrutura', 'Serviços', 'Bens em Geral']
  },
  dv: {
    id: 'dv',
    nome: 'Dois Vizinhos',
    sigla: 'DV',
    cidade: 'Dois Vizinhos',
    possuiSedes: false,
    mapStatus: 'completo',
    blocos: []
  },
  fb: {
    id: 'fb',
    nome: 'Francisco Beltrão',
    sigla: 'FB',
    cidade: 'Francisco Beltrão',
    possuiSedes: false,
    mapStatus: 'completo',
    blocos: []
  },
  gp: {
    id: 'gp',
    nome: 'Guarapuava',
    sigla: 'GP',
    cidade: 'Guarapuava',
    possuiSedes: false,
    mapStatus: 'completo',
    blocos: []
  },
  ld: {
    id: 'ld',
    nome: 'Londrina',
    sigla: 'LD',
    cidade: 'Londrina',
    possuiSedes: false,
    mapStatus: 'completo',
    blocos: []
  },
  md: {
    id: 'md',
    nome: 'Medianeira',
    sigla: 'MD',
    cidade: 'Medianeira',
    possuiSedes: false,
    mapStatus: 'completo',
    blocos: []
  },
  pb: {
    id: 'pb',
    nome: 'Pato Branco',
    sigla: 'PB',
    cidade: 'Pato Branco',
    possuiSedes: false,
    mapStatus: 'completo',
    blocos: []
  },
  pg: {
    id: 'pg',
    nome: 'Ponta Grossa',
    sigla: 'PG',
    cidade: 'Ponta Grossa',
    possuiSedes: false,
    mapStatus: 'completo',
    blocos: []
  },
  sh: {
    id: 'sh',
    nome: 'Santa Helena',
    sigla: 'SH',
    cidade: 'Santa Helena',
    possuiSedes: false,
    mapStatus: 'completo',
    blocos: []
  },
  td: {
    id: 'td',
    nome: 'Toledo',
    sigla: 'TD',
    cidade: 'Toledo',
    possuiSedes: false,
    mapStatus: 'completo',
    blocos: []
  }
};

export function listarCampus(): Campus[] {
  return Object.values(CAMPUS_DATA)
    .sort((a, b) => a.nome.localeCompare(b.nome));
}

export function buscarCampus(id: string): CampusConfig | null {
  return CAMPUS_DATA[id] || null;
}

export { CAMPUS_DATA };
export type { CampusConfig };
